import { create } from "zustand";

export type TaskStatusFilter = "all" | "enabled" | "paused" | "archived";
export type TaskTypeFilter = "all" | "scheduled" | "manual" | "triggered";
export type TaskSortOption = "last-run" | "next-run" | "name-az" | "name-za";

interface TeammateUIState {
	// Search and filters
	searchQuery: string;
	statusFilter: TaskStatusFilter;
	typeFilter: TaskTypeFilter;
	sortOption: TaskSortOption;

	// Task run panel
	selectedTaskId: number | null;
	isPanelOpen: boolean;

	// Actions
	setSearchQuery: (query: string) => void;
	setStatusFilter: (filter: TaskStatusFilter) => void;
	setTypeFilter: (filter: TaskTypeFilter) => void;
	setSortOption: (option: TaskSortOption) => void;
	setSelectedTask: (taskId: number | null) => void;
	closePanel: () => void;
	clearFilters: () => void;
	reset: () => void;
}

export const useTeammateUIStore = create<TeammateUIState>((set, _get) => ({
	// Initial state
	searchQuery: "",
	statusFilter: "enabled",
	typeFilter: "all",
	sortOption: "last-run",
	selectedTaskId: null,
	isPanelOpen: false,

	// Set search query
	setSearchQuery: (query: string) => {
		set({ searchQuery: query });
	},

	// Set status filter
	setStatusFilter: (filter: TaskStatusFilter) => {
		set({ statusFilter: filter });
	},

	// Set type filter
	setTypeFilter: (filter: TaskTypeFilter) => {
		set({ typeFilter: filter });
	},

	// Set sort option
	setSortOption: (option: TaskSortOption) => {
		set({ sortOption: option });
	},

	// Set selected task and open panel
	setSelectedTask: (taskId: number | null) => {
		set({
			selectedTaskId: taskId,
			isPanelOpen: taskId !== null,
		});
	},

	// Close panel
	closePanel: () => {
		set({
			isPanelOpen: false,
			selectedTaskId: null,
		});
	},

	// Clear all filters
	clearFilters: () => {
		set({
			searchQuery: "",
			statusFilter: "enabled",
			typeFilter: "all",
			sortOption: "last-run",
		});
	},

	// Reset all state (used on logout)
	reset: () => {
		set({
			searchQuery: "",
			statusFilter: "enabled",
			typeFilter: "all",
			sortOption: "last-run",
			selectedTaskId: null,
			isPanelOpen: false,
		});
	},
}));
